import React, { Component } from 'react'
import PropTypes from 'prop-types';

import { Accordion, Icon } from 'semantic-ui-react'


interface AccordionCardProps {
  isActive: boolean;
  index: number;
  handleClick: ClickHandler;
  textContent: string;
  title: string;
}

const AccordionCard: React.SFC<AccordionCardProps> = (props) => {
  return (
    <React.Fragment>
      <Accordion.Title
          active={props.isActive}
          index={props.index}
          onClick={props.handleClick}>
        <Icon name='dropdown' />
          {props.title}
      </Accordion.Title>
      <Accordion.Content active={props.isActive}>
        <p>
          {props.textContent}
        </p>
      </Accordion.Content>
      </React.Fragment>
    );
}

AccordionCard.propTypes = {
  handleClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  textContent: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

interface CardType {
  title: string;
  description: string;
}

interface ResultsAccordionProps extends React.Props<any> {
  cards: CardType[];
  activeIndex: number;
  handleResultClick: ClickHandler;
}

class ResultsAccordion extends Component<ResultsAccordionProps, any> {

  render() {
    const { cards, activeIndex, handleResultClick } = this.props;

    return (
      <Accordion fluid styled>
        {cards.map((card, index) => (
          <AccordionCard
            index={index}
            key={card.title}
            isActive={index === activeIndex}
            title={card.title}
            textContent={card.description}
            handleClick={handleResultClick}
          />
        ))}
      </Accordion>
    )
  }
}

export default ResultsAccordion;



// WEBPACK FOOTER //
// ./src/components/resultsAccordion/index.tsx